/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-cycle */
import baseApi from '@features/base/BaseSlice';
import humps from 'lodash-humps-ts';
import {
  ActiveUserReportsResponse,
  UserReportApiProps,
  UserReportHistoryParams,
  UserReportHistoryResponse,
  UserReportResponse,
} from './types';
import userReport from './userreport';

// Add Tag to the list of tags to be invalidated when the list of countries is updated
const userReportTag = baseApi.enhanceEndpoints({
  addTagTypes: [userReport.tagType],
});
const userReportApi = userReportTag.injectEndpoints({
  endpoints: (builder) => ({
    sendReport: builder.mutation<void, Partial<UserReportApiProps>>(
      {
        ...userReport.sendReport(),
        invalidatesTags: [{ type: userReport.tagType, id: 'LIST' }],
      },
    ),
    getActiveUserReports: builder.query<ActiveUserReportsResponse, void>({
      query: () => 'user-reports/active',
      transformResponse: (response: ActiveUserReportsResponse) => humps(response),
      providesTags: [{ type: userReport.tagType, id: 'LIST' }],
    }),
    getUserReports: builder.query<UserReportHistoryResponse, UserReportHistoryParams>({
      query: (params) => ({ url: 'user-reports', params }),
      transformResponse: (response: UserReportHistoryResponse) => humps(response),
      providesTags: [{ type: userReport.tagType, id: 'LIST' }],
    }),
    cancelUserReport: builder.mutation<UserReportResponse, number>({
      query: (id) => ({
        url: `user-reports/${id}`,
        method: 'PATCH',
        body: { state: 'canceled' },
      }),
      transformResponse: (response: UserReportResponse) => humps(response),
      invalidatesTags: [{ type: userReport.tagType, id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useSendReportMutation,
  useGetActiveUserReportsQuery,
  useGetUserReportsQuery,
  useCancelUserReportMutation,
} = userReportApi;
